import React from 'react';
import { useNetworkContext } from './NetworkContext';
import { networks } from './networks';

const toHex = (num) => {
  return "0x" + num.toString(16);
};

const SwitchNetwork = ({ provider }) => {
  const { selectedNetwork, setSelectedNetwork } = useNetworkContext();

  const handleNetworkChange = async (event) => {
    const chainId = parseInt(event.target.value, 10);
    const networkDetails = networks[chainId];
    setSelectedNetwork(networkDetails);

    try {
      await provider.provider.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: toHex(chainId) }],
      });
    } catch (error) {
      if (error.code === 4902) {
        try {
          await provider.provider.request({
            method: 'wallet_addEthereumChain',
            params: [networkDetails],
          });
        } catch (addError) {
          console.error(addError);
        }
      } else {
        console.error(error);
      }
    }
  };

  console.log("Selected Network in SwitchNetwork:", selectedNetwork); // Debugging line

  return (
    <>
      {/* 
      <select 
        onChange={handleNetworkChange} 
        value={selectedNetwork ? parseInt(selectedNetwork.chainId, 16) : ''} 
        className="networkDropdown"
      >
        <option value="" disabled>Select Network</option>
        {Object.keys(networks).map((networkKey) => (
          <option key={networkKey} value={networkKey}>
            {networks[networkKey].chainName}
          </option>
        ))}
      </select> 
      */}
      <w3m-network-button />
    </>
  );
};


export default SwitchNetwork;
